export const prepareLocationForApi = (location) => {
  const {
    placeId: place_id,
    mapUrl: map_url,
    formattedAddress: formatted_address,
    latitude,
    longitude,
    city,
    postal_code,
    route,
    street_number,
    street_address,
    administrative_area_level_1,
    administrative_area_level_1_short,
    administrative_area_level_2,
    country,
    name,
    data,
  } = location;

  const streetAddress = street_address || (street_number && route ? `${street_number} ${route}` : null);

  return {
    city: city || null,
    country: country || null,
    data: data || {},
    formatted_address: formatted_address || null,
    latitude: latitude || null,
    longitude: longitude || null,
    map_url: map_url || null,
    place_id: place_id || null,
    region: administrative_area_level_1 || null,
    region_short_name: administrative_area_level_1_short || null,
    subregion: administrative_area_level_2 || null,
    postcode: postal_code || null,
    street_address: streetAddress || null,
    name: name ?? formatted_address ?? null,
  };
};
